<template>
  <div>
    <div class="text-caption">
      <iri-value :iri="name" :highlights="highlights" humanize></iri-value>
    </div>

    <div
      ref="property-value"
      class="mb-1"
      :class="{ 'property-value-more': hasMore }"
      style="max-height: 140px; overflow: auto"
      @scroll="onScroll"
    >
      <scroll-list :items="objectProperty.values" :pageSize="10">
        <template v-slot:list-item="{ item: v }">
          <v-hover v-slot="{ hover }">
            <div class="mb-1 d-flex align-center">
              <!-- display: block -->
              <a
                style="display: block; flex-grow: 1"
                :class="{ 'grey lighten-4': hover }"
              >
                <!-- TODO consider renaming to successor (teh target in out-neighbor) -->
                <!-- TODO potentially remove the link when in edit mode -->
                <individual-signature :iri="v"> </individual-signature>
              </a>
              <span class="ml-2" style="background-color: transparent">
                <v-icon v-if="edit" @click="onDelete(v)"
                  >mdi-delete-outline</v-icon
                >
              </span>
            </div>
          </v-hover>
        </template>
      </scroll-list>
    </div>
  </div>
</template>

<script>
import IriValue from './IriValue.vue'
import IndividualSignature from './IndividualSignature.vue'
import ScrollList from '@/components/ScrollList.vue'

// import LiteralValue from './LiteralValue.vue'

import { ObjectProperty } from '@/rec-cache/rec-cache-types'

// The blur will dissapear when scrolled within this distance from end of the contents.
const blurThreshold = 14

export default {
  components: { IriValue, IndividualSignature, ScrollList },

  props: {
    objectProperty: {
      type: Object,
      default: () => {
        return new ObjectProperty()
      },
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    // TODO initialize in mounted... how to refer to correct div (perhaps easier if component with a slot)
    hasMore: false,
  }),
  computed: {
    name: function () {
      return this.objectProperty.name
    },
    // signature: function (iri) {
    //   const individual = this.$wob.read(iri)
    //   return individual.type + individual.label
    // },
  },
  mounted: async function () {
    console.log('components.object-property.mounted')
    const timer = Math.random().toString(36).slice(2, 7)

    console.time(timer)
    // TODO after use of scroll list two next ticks are needed before the list is rendered...
    await this.$nextTick()
    console.timeEnd(timer)

    // await this.$nextTick()
    const pv = this.$refs['property-value']
    this.hasMore =
      !!pv && pv.scrollHeight >= pv.scrollTop + pv.offsetHeight + blurThreshold
  },
  methods: {
    // Update the blur on the property value element.
    // TODO consider to throttle if performance at scroll deteriorates.
    onScroll: function (e) {
      this.hasMore =
        e.target.scrollHeight >=
        e.target.scrollTop + e.target.offsetHeight + blurThreshold
    },
    onDelete: function (iri) {
      console.log('ON DELETE', iri)
      this.$emit('delete', iri)

      // if (this.edit && this.objectProperty.isOne) {
      //   // Remove the object property if only one value is set
      //   this.$emit('delete', this.objectProperty)
      // } else {
      //   // TODO remove the specific iri, could be done with the index too, either ways this implementaiton doesnt support multi value on data property...
      //   this.objectProperty.removeValue(iri)
      // }
    },
  },
}
</script>

<style>
.property-value-more {
  -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
}

.property-value-active {
}
</style>
